// ProjectsStatsRow.tsx — Sprint 12. Top summary cards (Total, Active,
// Completed, Total Budget). Stateless: takes the orchestrator's
// already-summarised data.
import React from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import {
  CheckCircleOutlined, ClockCircleOutlined, DollarOutlined, ProjectOutlined,
} from '@ant-design/icons';
import type { ProjectSummary } from './projectTypes';
// Sprint 146 (R14-26) — the tile rendered `0.00CAD`: an AntD `prefix` icon plus
// a `suffix="CAD"` string, so the money had no `$` and trailed a bare currency
// code. Render the formatted value instead of asking Statistic to assemble it.
import { currency } from '../../utils/currency';

export interface ProjectsStatsRowProps {
  summary: ProjectSummary;
}

export const ProjectsStatsRow: React.FC<ProjectsStatsRowProps> = ({ summary }) => (
  <Row gutter={16} className="mb-6">
    <Col span={6}>
      <Card>
        <Statistic
          title="Total Projects"
          value={summary.totalProjects}
          prefix={<ProjectOutlined />}
        />
      </Card>
    </Col>
    <Col span={6}>
      <Card>
        <Statistic
          title="Active Projects"
          value={summary.activeProjects}
          valueStyle={{ color: '#faad14' }}
          prefix={<ClockCircleOutlined />}
        />
      </Card>
    </Col>
    <Col span={6}>
      <Card>
        <Statistic
          title="Completed Projects"
          value={summary.completedProjects}
          valueStyle={{ color: '#52c41a' }}
          prefix={<CheckCircleOutlined />}
        />
      </Card>
    </Col>
    <Col span={6}>
      <Card>
        <Statistic
          title="Total Budget"
          value={currency(summary.totalBudget)}
          prefix={<DollarOutlined />}
        />
      </Card>
    </Col>
  </Row>
);
